export default "__VITE_ASSET__gLGKQzOi__"